import axios from "../../longLiveAxios";

const baseURL = "/api/auth";
const baseUserURL = "/api/user";

export default {
  logout() {
    window.location = `/wk/logout`
  },
  getCurrentUser() {
    return axios.get(`${baseUserURL}/`);
  },
  updateUserEmail(payload) {
    return axios.put(`${baseUserURL}/email`, payload);
  },
  wkLogout(data) {
    window.location = `/wk/logout`
  }
}
